import getClosestOrgLikeTeamId from '@/utils/getClosestOrgLikeTeamId'

const getClosestOrgLikeTeam = (store, teamId) => {
  const parentTeamId = getClosestOrgLikeTeamId(store, teamId)
  return store.getters.teamById(parentTeamId)
}

export default getClosestOrgLikeTeam
